import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { IoIosHelpCircleOutline } from 'react-icons/io';
import { MdLock, MdPublic, MdShield } from 'react-icons/md';

export type TAccountProfilePrivacyModeProps = {
  name?: string;
  disabled?: boolean;
};

export const AccountProfilePrivacyMode: FC<TAccountProfilePrivacyModeProps> = ({ name = 'isPrivate', disabled }) => {
  const { control } = useFormContext();

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        height: '100%',
      }}
    >
      <Box>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 0.5,
            mb: 1.5,
            color: 'success.main',
          }}
        >
          <MdShield size={18} />
          <Typography variant="subtitle2" color="success.main">
            Privacy Mode
          </Typography>
        </Box>

        <Controller
          name={name}
          control={control}
          render={({ field }) => (
            <Stack direction="row" alignItems="center" spacing={2}>
              <ButtonGroup
                variant="outlined"
                size="small"
                sx={{
                  mb: 0.5,
                  '& .MuiButton-root': { px: 2 },
                }}
              >
                <Button
                  onClick={() => field.onChange(false)}
                  variant={field.value ? 'outlined' : 'contained'}
                  color={field.value ? 'inherit' : 'primary'}
                  startIcon={<MdPublic size={16} />}
                  disabled={disabled}
                >
                  Public
                </Button>
                <Button
                  onClick={() => field.onChange(true)}
                  variant={field.value ? 'contained' : 'outlined'}
                  color={field.value ? 'error' : 'inherit'}
                  startIcon={<MdLock size={16} />}
                  disabled={disabled}
                >
                  Private
                </Button>
              </ButtonGroup>
              <Tooltip title="When set to Private, you won't be visible in leaderboards, @mentions, or online presence features.">
                <Box sx={{ display: 'flex', cursor: 'pointer', color: 'text.secondary' }}>
                  <IoIosHelpCircleOutline size={30} />
                </Box>
              </Tooltip>
            </Stack>
          )}
        />
      </Box>
    </Box>
  );
};
